import { axiosInstance } from '@/config/axios.config';
import {
  CreateRecommendationRequest,
  Recommendation,
  UpdateRecommendationRequest,
} from '@repo/types/src/recommendation';

export const getAllRecommendations = async (): Promise<Recommendation[]> => {
  const response =
    await axiosInstance.get<Recommendation[]>('/recommendations');
  return response.data;
};

export const createRecommendation = async (
  payload: CreateRecommendationRequest,
): Promise<Recommendation> => {
  const response = await axiosInstance.post<Recommendation>(
    '/recommendations',
    payload,
  );
  return response.data;
};

export const updateRecommendation = async (
  id: number,
  payload: UpdateRecommendationRequest,
): Promise<Recommendation> => {
  const response = await axiosInstance.patch<Recommendation>(
    `/recommendations/${id}`,
    payload,
  );
  return response.data;
};

export const deleteRecommendation = async (
  id: number,
): Promise<Recommendation> => {
  const response = await axiosInstance.delete<Recommendation>(
    `/recommendations/${id}`,
  );
  return response.data;
};
